import { useEffect, useState, useMemo, useCallback } from "react";
import { RouteConfig } from "routes";
import { Socket } from "components/socket";
import axiosInstance from "utils/axiosInstance";
import { notifySuccess, notifyError } from "components/snackbar";
import Menuitems from "layouts/sidebar/MenuItems";
const usePermissionUtils = () => {
  const { routesForAuthenticatedOnly } = RouteConfig();

  const [state, setState] = useState({
    userId: null,
    token: null,
    accessPermission: [],
  });

  const { userId, accessPermission } = state;

  const updateState = (newState) => {
    setState((prevState) => ({ ...prevState, ...newState }));
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const access_token = localStorage.getItem("access_token");
    if (userData?.user?._id) {
      updateState({ userID: userData.user._id, token: access_token });
    }
  }, []);

  const getPermission = useCallback(async () => {
    try {
      const { data, status } = await axiosInstance.get(
        `/permission/getPermission/${userId}`
      );
      if (status === 200) {
        updateState({ accessPermission: data?.data });
      }
    } catch (err) {
      console.log("error", err);
    }
  }, [userId]);

  useEffect(() => {
    if (userId) getPermission();
  }, [userId, getPermission]);

  useEffect(() => {
    if (!Socket) return;
    Socket.on("userPermissionUpdated", (data) => {
      updateState({ accessPermission: data?.data });
    });
    return () => {
      Socket.off("userPermissionUpdated");
    };
  }, []);

  const notAllowedPermissions = useMemo(
    () => accessPermission.filter((item) => item.allowed === false),
    [accessPermission]
  );

  const updatedRoutesPermit = useMemo(
    () =>
      Menuitems?.filter(
        (route) =>
          !notAllowedPermissions.some(
            (permission) => permission.key === route.key
          )
      ),
    [notAllowedPermissions, Menuitems]
  );

  const PermissionCheck = useCallback(
    (key) => !notAllowedPermissions.some((ele) => ele.key === key),
    [notAllowedPermissions]
  );

  const CheckTabsPermissions = useCallback(
    (permissionList) => {
      const initialPermissions = {};
      permissionList.forEach((permission) => {
        initialPermissions[permission] = PermissionCheck(permission);
      });
      return initialPermissions;
    },
    [PermissionCheck]
  );

  const editAccessPermission = useCallback(
    async (userID, changePermission, setEdit) => {
      try {
        const body = { permissions: changePermission, userId: userID };
        const res = await axiosInstance.post(
          `api/permission/updateUserPermission`,
          body
        );

        if (res?.status === 200 || res?.status === 201) {
          setEdit(false);
          notifySuccess(res?.data?.msg || "Permissions updated successfully.");
        } else {
          notifyError("Failed to update permissions.");
        }
      } catch (error) {
        notifyError(
          error?.response?.data?.msg ||
            "An error occurred while updating permissions."
        );
      }
    },
    []
  );

  return {
    updatedRoutesPermit,
    PermissionCheck,
    CheckTabsPermissions,
    accessPermission,
    updateState,
    getPermission,
    editAccessPermission,
  };
};

export default usePermissionUtils;
